import { Player } from '../../jscaip/Player';
import { GameStateWithTable } from '../../jscaip/state/GameStateWithTable';
import { PlayerOrNoneGameStateWithTable } from '../../jscaip/state/PlayerOrNoneGameStateWithTable';
export class QuebecCastlesState extends PlayerOrNoneGameStateWithTable {
    castles;
    static of(oldState, newBoard) {
        return new QuebecCastlesState(newBoard, oldState.turn, oldState.castles);
    }
    constructor(board, turn, castles) {
        super(board, turn);
        this.castles = castles;
        this.castles.makeImmutable();
    }
    incrementTurn() {
        return new QuebecCastlesState(this.getCopiedBoard(), this.turn + 1, this.castles);
    }
    setPieceAt(coord, value) {
        return GameStateWithTable.setPieceAt(this, coord, value, QuebecCastlesState.of);
    }
    isCastleAt(coord) {
        const castleZero = this.castles.get(Player.ZERO);
        const castleOne = this.castles.get(Player.ONE);
        return castleZero.equalsValue(coord) ||
            castleOne.equalsValue(coord);
    }
}
